import React,{ useEffect, useState } from "react"
import { Table } from "reactstrap";
import PerformancePlanRows from "./PerformancePlanRows"
function AddDelPerformancePlan({setData,performancePlanList,enableEdit,isReview}){
    
    const [rowsData, setRowsData] = useState([]);
 
    const addTableRows =React.useCallback(()=>{
  
        const rowsInput={
            performanceplan:'',
            dependency:'',
            performancePlanId : 0
        } 
        setRowsData([...rowsData, rowsInput])
      
    },[setRowsData,rowsData]);
   const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
        setData(rows);
   }
 
   const handleChange = (index, evnt)=>{    
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput); 
    setData(rowsData);

  }
  useEffect(()=>{
    if(performancePlanList!=null && performancePlanList.length>0){
        let arry = [];
       for(var i=0;i<performancePlanList.length;i++) {
            var rowsInput = {
                performanceplan: performancePlanList[i].performance_plan || performancePlanList[i].performanceplan || "",
                dependency: performancePlanList[i].dependency || "",
                performancePlanId: performancePlanList[i].performancePlanId || performancePlanList[i].performance_plan_Id || 0
            }
            arry.push(rowsInput);
        }
        setRowsData(arry);
        setData(arry);
    } else {
        setRowsData([]);
        setData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[performancePlanList]);
    return(
            <div className="row">
                <div className="col-sm-12">
                <Table isLoading={true}>
                    <thead className="performance-table">
                      <tr>
                          <th>Performance Goals (KRAs)</th>
                          <th>Dependency</th>
                          <th><button type="button" 
                          className="btn-admin-settings btn" 
                          onClick={addTableRows} 
                          style={isReview?{display:"block"}:{display:"none"}}
                          >+</button></th>
                      </tr>
                    </thead>
                    <tbody>
                   <PerformancePlanRows
                    rowsData={rowsData} 
                    deleteTableRows={deleteTableRows} 
                    handleChange={handleChange} 
                    enableEdit={enableEdit}
                    isReview={isReview}/>
                   </tbody> 
                </Table> 
                </div>
                <div className="col-sm-4">
                </div>
            </div>
    )

}
export default AddDelPerformancePlan